import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ROUTES } from './user.routes';
import {
  UserMainComponent,
  UserPropertiesComponent,
  EditProfileComponent,
  ProfileComponent,
  ChangePasswordComponent
} from './pages';
import { UserPropertyListComponent } from './components';
import { SharedModule } from '../../shared';
import { PropertyModule } from '../property';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserService } from './services';
import { ModalModule } from 'ngx-bootstrap/modal';
import { InternalSharedModule } from '../shared';
import { EffectsModule } from '@ngrx/effects';
import { UserEffects } from './redux/user.effects';
import { CommonModule } from '@angular/common';
import { DxFileUploaderModule } from 'devextreme-angular';
import { DxPaginationModule } from 'devextreme-angular/ui/pagination';

const PROVIDERS = [
  UserService
];

@NgModule({
  declarations: [
    UserPropertyListComponent,
    UserMainComponent,
    UserPropertiesComponent,
    EditProfileComponent,
    ProfileComponent,
    ChangePasswordComponent,
  ],
  imports: [
    CommonModule,
    EffectsModule.forFeature([UserEffects]),
    RouterModule.forChild(ROUTES),
    ModalModule,
    SharedModule,
    InternalSharedModule,
    PropertyModule,
    FormsModule,
    ReactiveFormsModule,
    DxFileUploaderModule,
    DxPaginationModule
  ],
  providers: [
    PROVIDERS
  ],
  exports: [
    UserMainComponent,
    UserPropertiesComponent,
    EditProfileComponent,
    ProfileComponent,
    ChangePasswordComponent
  ]
})
export class UserModule { }
